
<div class="error-page-container">
    <div class="error-page"> <!--[ngClass]="{pagebg: !isLoggedIn}"-->
        <div>{{ errorCode }}</div>
        <div>{{ errorText | translate }}</div>
        <div>
            <a class="btn btn-light btn-sm" [routerLink]="linkUrl">{{ linkText | translate }}</a>
        </div>
    </div>
</div>